import React from 'react';
import { useTranslation } from 'react-i18next';
import { Text, Flex, RectangularButton } from '@resideo/blueprint-react';
import ModalHeader from 'components/common/ModalHeader';
import Link from 'components/common/Link';

export const DeleteUserModal = ({ onCancel, onSubmit }) => {
  const { t } = useTranslation();

  return (
    <>
      <ModalHeader
        title={t('deleteUser.modalTitle')}
        textAlign='center'
        closeModal={onCancel}
      />
      <Text
        data-test-delete-user-modal-text
        marginBottom='small'
        paddingBottom={'medium'}
        justifyContent='center'>
        {t('deleteUser.modalText')}
      </Text>
      <Flex flexDirection='column'>
        <RectangularButton
          data-test-delete-user-modal-submit-button
          type='button'
          variant='secondary'
          onClick={onSubmit}>
          {t('deleteUser.yesButton')}
        </RectangularButton>
        <Flex
          width={'100%'}
          padding={20}
          paddingBottom={0}
          justifyContent='center'>
          <Link data-test-delete-user-modal-cancel-button onClick={onCancel}>
            {t('deleteUser.noButton')}
          </Link>
        </Flex>
      </Flex>
    </>
  );
};
